import { createStyle } from '@gluestack-style/react';

export const FormControlHelper = createStyle({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  mt: '$1',
});
